<template><ListFilter field="short_description" :options="opts" label="Краткое описание" @filter="$emit('filter',$event)" @openDetail="$emit('openDetail',$event)"/></template>
<script>
import ListFilter from './ListFilter.vue'
export default { name:'ShortDescriptionFilter', components:{ListFilter}, data(){ return { opts:['алевролит','алевролитово-песчаная порода','глина','глинисто-алевролитовая порода','жемчуг','известняк','карбонатная порода','корал','лягушка','песчаник','часы'] } } }
</script>
